module.exports = __webpack_public_path__ + "img/Frame-67.857ab1ba.svg";